// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes shimmer-loading--i3HmY{0%{background-position:200% 0}100%{background-position:-200% 0}}.themes-page--PpYKG{background-color:#fff}.hero-subtitle--GMTQk{max-width:620px;margin:0 auto;color:#5a6272}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"themes-page": "themes-page--PpYKG",
	"hero-subtitle": "hero-subtitle--GMTQk",
	"shimmer-loading": "shimmer-loading--i3HmY"
};
export default ___CSS_LOADER_EXPORT___;
